import { Injectable, NgZone } from '@angular/core';
import { LOCAL_IMAGES } from '@app/core/constants/img-constants';
import { STORAGE_CONST } from '@app/core/constants/storage-constants';
import { ApiDomainService } from '@app/core/http/api-domain/api-domain.service';
import { DomainInfo } from '@app/shared/models/DomainInfo';
import { SharedService } from '../shared/shared.service';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class DomainService {
  constructor(
    private apiDomainSvc: ApiDomainService,
    private sharedSvc: SharedService,
    private storage: StorageService,
    private zone: NgZone
  ) {}

  async domainDetails(domainName: string): Promise<DomainInfo> {
    try {
      const response = await this.apiDomainSvc.getDomainDetails(domainName);
      return response.data as DomainInfo;
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  async domainInfo(customerId): Promise<DomainInfo> {
    try {
      const response = await this.apiDomainSvc.getDomianInfo(customerId);
      if (response.status && response.error == null) {
        var a = response.data as DomainInfo;
        return a;
      } else {
        console.error(response.error);
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  async saveDomainInfo(data: DomainInfo, locationId: string, deviceId: string) {
    return new Promise(async (resolve, reject) => {
      try {
        this.sharedSvc.getCustomerDetails = data;
        this.sharedSvc.setCurrencySymbol();
        const { DomainName, _id } = data.customerData;
        const location = data.customerData.CustomerName;
        const device_id = deviceId;
        const root = document.querySelector(':root');
        root['style'].setProperty('--ion-color-eprintprimary', data.customizations.Hex500);
        root['style'].setProperty(
          '--ion-color-eprinthighlighted',
          'var(--ion-color-eprintprimary-contrast)'
        );

        let selectedLocation = data.locations.find((loc) => loc._id === locationId);

        const domaininfo = {
          domainname: DomainName,
          location,
          device_id,
          locationId,
          customerId: _id,
          locationName: selectedLocation?.Location || '',
        };

        this.zone.run(() => {
          this.sharedSvc.domaininfo = domaininfo;
          this.sharedSvc.drawerHeaderLogo =
            data?.customizationsText?.LogoMobile?.Url || LOCAL_IMAGES.eprintitLogo;

          // if(!this.loginAccountService.autoAccountAvail$?.value){
          //   this.sharedSvc.showAccountOnlySection =
          //     data?.customizationsText?.UserInformationSection
          //       ?.ValidationVisibility ?? false;
          // }
        });
        // if (!this.sharedSvc.showAccountOnlySection) {
        //   this.zone.run(() => {
        //     this.sharedSvc.accountOnly = false;
        //   });
        // }
        this.sharedSvc.setDomainInfo(data);
        await this.storage.setJson(STORAGE_CONST.DOMAIN_INFO, domaininfo);

        if (this.sharedSvc.fileData != null && this.sharedSvc.uploadedFiles.length > 0) {
          this.sharedSvc.dataArrayUploadFile.forEach((file) => {
            file.duplex = data.jobLists[0].DefaultValues.Duplex;
            file.layout = data.jobLists[0].DefaultValues.Orientation;
            file.paperSize = data.jobLists[0].DefaultValues.PaperSize;
            file.printType = data.jobLists[0].DefaultValues.Color;
          });
        }
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }

  async loadDomainInfo() {
    const customerDetail = await this.sharedSvc.getCustomerInfo();
    const domainDetail = await this.sharedSvc.getDomainInfo();
    if (customerDetail && domainDetail) {
      this.sharedSvc.domaininfo = domainDetail;
      await this.saveDomainInfo(customerDetail, domainDetail.locationId, domainDetail.device_id);
    }
    return;
  }

  handleParams(params) {
    if (params) {
      const { domainname, locationid, deviceid } = params;
      // let deviceid = params.deviceid;
      if (typeof domainname !== 'undefined' && typeof locationid !== 'undefined') {
        this.selectedDomainInfo(domainname, locationid, deviceid);
      }
    }
  }

  async selectedDomainInfo(domainName: any, locationid: string, deviceid: string) {
    try {
      this.sharedSvc.selectedDomainThroughURL = true;
      const data = await this.domainDetails(domainName);
      await this.saveDomainInfo(data, locationid, deviceid);
    } catch (error) {
      console.error(error);
    }
  }
}
